<template>
<div class="kt-header__topbar-item theme-toggle">
    <button type="button"
            class="theme-toggle__btn"
            :aria-pressed="theme === 'dark' ? 'true' : 'false'"
            :title="theme === 'dark' ? $t('light_mode') : $t('dark_mode')"
            :aria-label="theme === 'dark' ? $t('light_mode') : $t('dark_mode')"
            @click="toggle">
        <i :class="theme === 'dark' ? 'fas fa-sun' : 'fas fa-moon'"></i>
    </button>
</div>
</template>

<script>
import { currentTheme, toggleTheme } from '@/plugins/theme'

export default {
    data() {
        return {
            theme: currentTheme(),
        }
    },
    methods: {
        toggle() {
            this.theme = toggleTheme()
        }
    }
}
</script>
